module.exports = __webpack_public_path__ + "static/media/react1Fetch.b5fcc793.png";